import { Screens } from 'core/CssVariables';
import styled from 'styled-components';

const SCreateButtonWrapper = styled.div`
  /* The dashbar's own call to action: scoped here rather than to the shared
     Info button so the rest of the app keeps its current palette (ZEST-757). */
  button {
    background-color: ${props => props.theme.dashbar.ctaColor};
    border-color: ${props => props.theme.dashbar.ctaColor};
    border-radius: 12px;
    font-weight: 500;

    &:hover,
    &:focus {
      background-color: ${props => props.theme.dashbar.ctaColor};
      border-color: ${props => props.theme.dashbar.ctaColor};
      opacity: 0.9;
    }
  }

  @media (max-width: ${Screens.ScreensMD}) {
    button {
      padding: 8px;
    }
    span {
      display: none;
    }
    .icon {
      margin-right: 0px;
    }
  }
`;

export { SCreateButtonWrapper };
